import { GuestPropertiesListScreen } from '@/modules/guest-web';
import { GuestRouteGate } from '@/modules/guest-web/components/GuestRouteGate';

/** Public guest property list — `/guest` (flat file route for static export). */
export default function GuestListRoute() {
  return (
    <GuestRouteGate>
      <GuestPropertiesListScreen />
    </GuestRouteGate>
  );
}
